var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "func-modal",
    {
      ref: "modal",
      attrs: { title: _vm.modalTitle },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function(props) {
            return [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  class: { disabled: _vm.processing },
                  attrs: { disabled: _vm.processing },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.submit(props)
                    }
                  }
                },
                [
                  _vm.processing
                    ? _c("span", [
                        _c("i", { staticClass: "fa fa-spin fa-spinner" }),
                        _vm._v("\n        Saving...\n      ")
                      ])
                    : _c("span", [_vm._v("\n        Save\n      ")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return props.close()
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("template", { slot: "body" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("API Route")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.form.route,
                expression: "form.route",
                modifiers: { trim: true }
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "e.g. api.locations.all" },
            domProps: { value: _vm.form.route },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "route", $event.target.value.trim())
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          _vm.errors.route
            ? _c("div", { staticClass: "text-danger" }, [
                _vm._v("\n        " + _vm._s(_vm.errors.route[0]) + "\n      ")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Max Requests")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.form.max_requests,
                expression: "form.max_requests",
                modifiers: { number: true }
              }
            ],
            staticClass: "form-control",
            attrs: { type: "number", min: "1", placeholder: "e.g. 100" },
            domProps: { value: _vm.form.max_requests },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "max_requests", _vm._n($event.target.value))
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          _vm.errors.max_requests
            ? _c("div", { staticClass: "text-danger" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.errors.max_requests[0]) + "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Period")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedPeriod,
                  expression: "selectedPeriod"
                }
              ],
              staticClass: "form-control",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedPeriod = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.onPeriodChange
                ]
              }
            },
            _vm._l(_vm.periods, function(period) {
              return _c(
                "option",
                { key: period.value, domProps: { value: period.value } },
                [_vm._v("\n          " + _vm._s(period.label) + "\n        ")]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Window (seconds)")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.form.window_seconds,
                expression: "form.window_seconds",
                modifiers: { number: true }
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "number",
              min: "1",
              placeholder: "e.g. 60",
              disabled: _vm.selectedPeriod !== "custom"
            },
            domProps: { value: _vm.form.window_seconds },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.form,
                  "window_seconds",
                  _vm._n($event.target.value)
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          _vm.errors.window_seconds
            ? _c("div", { staticClass: "text-danger" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.errors.window_seconds[0]) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "checkbox" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.is_enabled,
                    expression: "form.is_enabled"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.form.is_enabled)
                    ? _vm._i(_vm.form.is_enabled, null) > -1
                    : _vm.form.is_enabled
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.form.is_enabled,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.form, "is_enabled", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.form,
                            "is_enabled",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.form, "is_enabled", $$c)
                    }
                  }
                }
              }),
              _vm._v("\n          Enabled\n        ")
            ])
          ]),
          _vm._v(" "),
          _vm.errors.is_enabled
            ? _c("div", { staticClass: "text-danger" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.errors.is_enabled[0]) + "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.showRouteExamples = !_vm.showRouteExamples
                }
              }
            },
            [
              _c("i", {
                class: _vm.showRouteExamples
                  ? "fa fa-caret-up"
                  : "fa fa-caret-down",
                attrs: { "aria-hidden": "true" }
              }),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.showRouteExamples ? "Hide" : "Show") +
                  " route examples\n      "
              )
            ]
          ),
          _vm._v(" "),
          _vm.showRouteExamples
            ? _c("div", { staticClass: "margin-top-2x" }, [
                _c("p", { staticClass: "text-muted" }, [
                  _c("small", [
                    _vm._v("Click a route to auto-fill the API Route field.")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { "max-height": "200px", "overflow-y": "auto" }
                  },
                  _vm._l(_vm.routeExamples, function(route) {
                    return _c(
                      "div",
                      { key: route, staticClass: "margin-bottom-1x" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "text-info",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.selectRoute(route)
                              }
                            }
                          },
                          [_vm._v(_vm._s(route))]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-356560c0", { render: render, staticRenderFns: staticRenderFns })
  }
}